import React, { forwardRef } from 'react';

interface LoadingTriggerRowProps {
  colSpan: number;
  hasMoreData: boolean;
  loadingMore: boolean;
}

const LoadingTriggerRow = forwardRef<
  HTMLTableRowElement,
  LoadingTriggerRowProps
>(({ colSpan, hasMoreData, loadingMore }, ref) => {
  if (!hasMoreData) return null;

  return (
    <tr ref={ref}>
      <td colSpan={colSpan} className="text-center p-3">
        {loadingMore ? (
          <div>
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading more...</span>
            </div>
          </div>
        ) : (
          <div className="text-muted small">Scroll down to load more...</div>
        )}
      </td>
    </tr>
  );
});

LoadingTriggerRow.displayName = 'LoadingTriggerRow';

export default LoadingTriggerRow;
